module.exports = __webpack_public_path__ + "img/top_partner.7aa61cc6.jpg";